export default {
  greenLight: {
    text: 'Green',
    value: 'green_light',
  },
  yellowLight: {
    text: 'Yellow',
    value: 'yellow_light',
  },
  redLight: {
    text: 'Red',
    value: 'red_light',
  },
  blueLight: {
    text: 'Blue',
    value: 'blue_light',
  },
};
